export default "__VITE_ASSET__DSu26KKz__"